import { WebRoute } from "routes";

export const RISK_MODULE = "/risks";

export const NEW_RISK_DIRECTORY = RISK_MODULE + "/new";

export const RISK_DIRECTORY_STRUCTURE = "/structure";
export const RISK_DIRECTORY_STRUCTURE_PROTO = "/structure-editor-prototype";

export const NEW_ENTITY = WebRoute.RISK_ENTITIES + "/new";

export const RISK_DIRECTORY_VIEW = RISK_MODULE;
